<script>
// import Swiper JS
import Swiper from "swiper";
// import Swiper styles
import "swiper/swiper-bundle.css";
import SwiperCore, { Navigation, Pagination } from "swiper/core";

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination]);
export default {
  name: "relacionamentos-de-valor",
  data() {
    return {};
  },
  computed: {
    relationships() {
      return this.$store.state.relationship;
    },
  },
  mounted() {
    const _this = this;
    var swiper = new Swiper(this.$refs["mySwiper4"], {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet(index, className) {
          return (
            '<span class="' +
            className +
            '">' +
            `<img src="${_this.relationships[index].icon}" />` +
            "</span>"
          );
        },
      },
    });
  },
};
</script>

<template>
  <section class="values">
    <div class="container">
      <header>
        <h1 class="title">RELACIONAMENTOS DE VALOR</h1>
      </header>

      <div class="swiper-container mySwiper4" ref="mySwiper4">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(relationship, index) in relationships"
            :key="index"
          >
            <div class="swiper-slide__card">
              <div class="text">
                <div class="box-red"></div>
                <div class="context">
                  <p>
                    {{ relationship.profile.text }}
                  </p>
                  <h4>
                    {{ relationship.profile.name }},
                    <small>
                      {{ relationship.profile.office }}
                    </small>
                  </h4>
                </div>
              </div>
              <div class="profile-capa">
                <img :src="relationship.banner" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </section>
</template>


<style lang="scss">

.values {
  .swiper-pagination {
    position: absolute;
    top: 10px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: auto !important;
  }
  .swiper-pagination-bullet {
    border-radius: 0;
    width: auto;
    height: 70px;
    text-align: center;
    font-size: 12px;
    opacity: 1;
    background: #fff;
    margin: 0px 0.5rem !important;
    border-radius: 50%;
    img {
      height: 100%;
      filter: grayscale(100%);
      &:hover {
        filter: grayscale(0%);
      }
    }
    @include media-breakpoint-down(lg) {
      height: 50px;
    }
  }
  .swiper-pagination-bullet-active {
    background: #fff;
    border: 3.5px solid theme-color(primary);
    img {
      filter: grayscale(0%);
    }
  }
}
</style>

<style lang="scss" scoped>
.values {
  background-color: #fff;
  padding: 3rem 0px;
  @include media-breakpoint-down(lg) {
    padding: 1rem 0px 3rem 0px;
  }
  h1 {
    margin: 1rem 0px 3rem 0px;
  }
  .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }

  .swiper-slide {
    overflow: hidden;
    background: #fff;
    box-sizing: border-box;
    font-family: "Lato", sans-serif;
    &__card {
      margin-top: 9.5rem;
      display: flex;
      align-items: center;
      width: 100%;
      @include media-breakpoint-down(lg) {
        flex-direction: column;
      }
      .text {
        width: 55%;
        z-index: 99;
        display: block;
                position: relative;
        transition: position .6s ease-in-out;
        @include media-breakpoint-down(lg) {
          order: 2;
          width: 100%;
        }
          @include media-breakpoint-down(sm) { 
                    position: absolute;
           }
        .box-red {
          position: absolute;
          background-color: theme-color(primary);
          padding: 5rem 6.5rem;
          border-radius: 8px;
          z-index: -1;
          top: -2.5rem;
          left: 0rem;
          @include media-breakpoint-down(lg) {
            padding: 2rem 3.5rem;
            left: 1rem;
            top: -1.5rem;
          }
        }
        h4 {
          text-align: left;
          margin-top: 1.5rem;
          small {
            display: block;
            margin-top: 0.8rem;
          }
        }
        .context {
          background-color: theme-color(secondary);
          color: #fff;
          padding: 3rem 3rem;
          margin-right: -5rem;
          margin-left: 3rem;
          border-radius: 8px;
          @include media-breakpoint-down(lg) {
            margin-right: 0rem;
            margin-left: 0rem;
            padding: 2rem;
          }
        }
        p {
          color: #fff;
          font-weight: 300;
          text-align: left;
          font-size: 1.2rem;
          line-height: calc(1.2rem * 1.7);
          @include media-breakpoint-down(lg) {
            font-size: 1rem;
            line-height: calc(1rem * 1.7);
          }
        }
      }
      .profile-capa {
        width: 55%;
        position: relative;
        z-index: 9;
        @include media-breakpoint-down(lg) {
          width: 100%;
          order: 1;
          img {
            width: 80% !important;
          }
          margin-top: 0rem;
        }
        img {
          width: 100%;
        }
      }
    }
  }
       @include media-breakpoint-down(sm) { 
    .swiper-slide-active {
   .swiper-slide__card {
      .text {
  position: relative;
      }
    }
  
  }
        }


}
</style>